export const languagesOptions = [
  {
    text: 'Ελληνικά',
    value: 'el',
  },
  {
    text: 'English',
    value: 'en',
  },
];
export const regionOptions = [
  {
    text: 'Αθήνα',
    value: 'Αθήνα',
  },
  {
    text: 'Θεσσαλονίκη',
    value: 'Θεσσαλονίκη',
  },
  {
    text: 'Πάτρα',
    value: 'Πάτρα',
  },
  {
    text: 'Λάρισα',
    value: 'Λάρισα',
  },
  {
    text: 'Ηράκλειο',
    value: 'Ηράκλειο',
  },
  {
    text: 'Άλλη περιοχή',
    value: 'Άλλη περιοχή',
  },
];

export const contractTypeOptions = [
  {
    text: 'Open',
    value: 0,
  },
  {
    text: 'Fixed',
    value: 1,
  },
];

export const kilometersOptions = [
  {
    text: 'Μηχανάκια (1200)',
    value: '1200',
  },
  {
    text: 'Default (1667)',
    value: '1667',
  },
  { text: 'Van (2500)', value: '2500' },
];

export const contractOptions = [
  {
    text: 'Ιδιώτης',
    value: 'Ιδιώτης',
  },
  {
    text: 'Ατομική Επιχείρηση',
    value: 'Ατομική Επιχείρηση',
  },
  {
    text: 'Ανώνυμη Εταιρεία (Α.Ε.)',
    value: 'Ανώνυμη Εταιρεία (Α.Ε.)',
  },
  {
    text: 'Ομόρρυθμη Εταιρεία (Ο.Ε.)',
    value: 'Ομόρρυθμη Εταιρεία (Ο.Ε.)',
  },
  {
    text: 'Ετερόρρυθμη Εταιρεία (Ε.Ε.)',
    value: 'Ετερόρρυθμη Εταιρεία (Ε.Ε.)',
  },
  {
    text: 'Ε.Π.Ε.',
    value: 'Ε.Π.Ε.',
  },
  {
    text: 'Ι.Κ.Ε.',
    value: 'Ι.Κ.Ε.',
  },
];

export const holdingCompanyOptions = [
  {
    text: 'instacar',
    value: 'hq',
  },
  {
    text: 'instaride / kineo',
    value: 'instaride',
  },
];

export const companyOptions = [
  {
    text: 'instacar',
    value: 'instacar',
  },
  {
    text: 'guruleasing',
    value: 'guruleasing',
  },
  {
    text: 'seleo',
    value: 'seleo',
  },
];

export const referralIdOptions = [
  { value: 'ANA', text: 'ANA' },
  { value: 'ATR', text: 'ATR' },
  { value: 'BFS', text: 'BFS' },
  { value: 'COA', text: 'COA' },
  { value: 'COS', text: 'COS' },
  { value: 'CRT', text: 'CRT' },
  { value: 'DEL', text: 'DEL' },
  { value: 'FRT', text: 'FRT' },
  { value: 'GUR', text: 'GUR' },
  { value: 'KAR', text: 'KAR' },
  { value: 'LAG', text: 'LAG' },
  { value: 'LAM', text: 'LAM' },
  { value: 'LRS', text: 'LRS' },
  { value: 'PAP', text: 'PAP' },
  { value: 'SKG', text: 'SKG' },
  { value: 'TEM', text: 'TEM' },
  { value: 'TLM', text: 'TLM' },
  { value: 'TSA', text: 'TSA' },
  { value: 'VENT', text: 'VENT' },
  { value: 'ZCH', text: 'ZCH' },
];

export const fixedContractPeriods = [{}];
